module.exports = __webpack_public_path__ + "img/mind_skeleton_100.7fe2659a.png";